import { useContext, useEffect, useState } from "react";
import { Context } from "../../../hooks/useAuthContext";
import "./styles.css";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import APP_VERSION from "../../../components/UI/APP_VERSION";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function Login() {
  const { login, loading, userData } = useContext(Context);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (userData?.uid) {
      if (
        userData.tipoConta !== "usuario" &&
        userData.tipoConta !== "influenciador"
      ) {
        navigate("/admin");
      }
    }
  }, []);

  const handleLogin = async () => {
    if (email === "" || password === "") {
      toast.error("Email e Senha devem ser preenchidos!");
      return;
    }

    await login(email, password);
  };

  return (
    <>
      <div className="containerLogin">
        <div className="login">
          <div className="logo">
            <img src="https://i.imgur.com/bMhAXFy.png" alt="Logo link do bem" />
          </div>

          <div className="formLogin">
            <div className="titleText">Acesse sua conta agora</div>
            <form className="form">
              <div className="formGroup">
                <label htmlFor="email">Email</label>
                <input
                  id="email"
                  className="inputForm"
                  type="email"
                  placeholder="Digite seu email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="formGroup">
                <label htmlFor="password">Senha</label>
                <div className="password-container">
                  <input
                    id="password"
                    className="inputForm"
                    type={showPassword ? "text" : "password"}
                    placeholder="********"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  <span
                    className="password-icon"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
                <span style={{ marginTop: 5, fontSize: 14 }}>
                  Esqueceu sua senha?{" "}
                  <Link to="/recuperar-senha">Recuperar agora</Link>
                </span>
              </div>

              <button
                type="button"
                onClick={handleLogin}
                disabled={loading && true}
              >
                {loading ? "Entrando..." : "Entrar"}
              </button>
            </form>
            <span className="linkCadastro">
              Não tem uma conta? <Link to="/cadastro">Cadastre-se!</Link>
            </span>
          </div>
        </div>
      </div>
      <APP_VERSION />
    </>
  );
}

export default Login;
